import React, { useState, useEffect } from "react";
import {
  processFormValuesPatch,
  processFormValuesPost,
  renderFormInput,
} from "../../../../modules/formTools";
import DropzoneArea from "../../../../Components/Form/File/DropzoneArea";
import { handleDownload } from "../../../../services/downloadFile";
import {
  ButtonPrimary,
  ButtonPrimaryRed,
  ButtonSpan,
} from "../../../../Components/Button";
import Loading from "../../../../Components/Loading";
import { isRolePlatformAdmin, token } from "../../../../modules/auth";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { allowedDocMimeTypes, preAddUrl } from "../../../../utils";
import {
  fetchCompanyFiles,
  removeCompanyFile,
  uploadCompanyFile,
} from "../../../../redux/actions/company-files";
import moment from "moment";
import Succeeded from "../../../../Components/Form/Succeeded";
import { LiveSearchSimple } from "../../../../Components/Form/LiveSearch/LiveSearchSimple";
import { editCompany } from "../../../../redux/actions";
import CompanyNoteField from "../../../../Components/corporate/CompanyNoteField";
import CompanyTargetsForm from "../../../../Components/corporate/CompanyTargetsForm";

const mapStateToProps = (state, props) => {
  return {
    ...state.companyFiles,
    token: token(state),
    isRolePlatformAdmin: isRolePlatformAdmin(state),
  };
};

const mapDispatchToProps = {
  fetchCompanyFiles,
  uploadCompanyFile,
  removeCompanyFile,
  editCompany,
};

let CompanyAgency = ({
  handleSubmit,
  change,
  token,
  submitting,
  uploadCompanyFile,
  fetchCompanyFiles,
  companyFiles,
  isFetchingCompanyFiles,
  company,
  removeCompanyFile,
  isRolePlatformAdmin,
  editCompany,
}) => {
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [fileExtension, setFileExtension] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [fileError, setFileError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [agency, setAgency] = useState({});
  useEffect(() => {
    fetchCompanyFiles(company.id, token);
  }, []);

  let onSubmit = formValues => {
    const formData = new FormData();
    setLoading(true);
    Object.entries(formValues).forEach(([key, value]) =>
      formData.append(key, value)
    );
    if (file) {
      formData.append("file", file);
    }
    uploadCompanyFile(formData, company.id, token).then(r => {
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        setLoading(false);
        fetchCompanyFiles(company.id, token);
      }, 1000);
    });
  };
  let uploadFile = file => {
    let acceptedTypes = allowedDocMimeTypes();
    if (acceptedTypes.includes(file[0].type)) {
      setUploading(true);
      setFile(file[0]);
      setUploading(false);
      setFileError(false);
    } else {
      setFileError(true);
    }
  };
  let assignAgency = () => {
    const formValues = {
      _method: "PATCH",
      agency_id: agency.id,
    };
    if (
      window.confirm(
        "Are you sure you want to assign this Company to " + agency.name
      )
    ) {
      return editCompany(company.id, formValues, token).then(
        response => window.location.reload()
      );
    }
  };
  let headings = () => {
    return (
      <tr>
        <th>Name</th>
        <th>Uploaded At</th>
        <th>Actions</th>
      </tr>
    );
  };
  let fileList = () => {
    if (
      typeof companyFiles === "undefined" ||
      Object.entries(companyFiles).length === 0
    ) {
      return (
        <tr>
          <td colSpan={3}>
            <div>No files available for this company</div>
          </td>
        </tr>
      );
    }

    if (companyFiles.length === 0 || isFetchingCompanyFiles) {
      return null;
    }

    return companyFiles
      .sort(
        (a, b) =>
          moment(b.updated_at).format("YYYYMMDD") -
          moment(a.updated_at).format("YYYYMMDD")
      )
      .map(file => {
        if (file.url === null && file.external_link === null) {
          return;
        }
        return (
          <tr key={file.id}>
            <td>
              <div className="flex items-center">
                <div>{file.name}</div>
              </div>
            </td>
            <td>
              <div className="flex items-center content-center">
                <div className={""}>
                  {moment(file.updated_at).format("DD/MM/YYYY")}
                </div>
              </div>
            </td>
            <td>
              <div className="flex items-center content-center">
                <div className={""}>
                  {typeof file.path !== "undefined" && file.path ? (
                    <a
                      className={"text-sm font-medium"}
                      href="#"
                      onClick={() =>
                        handleDownload(
                          file?.name,
                          file?.url,
                          file?.extension,
                          token
                        )
                      }
                    >
                      <i className="fal fa-file-download fa-1x" />
                    </a>
                  ) : (
                    <a
                      className={"text-sm font-medium"}
                      href={preAddUrl(file.external_link)}
                      target={"_blank"}
                    >
                      <i className="fal fa-external-link fa-1x" />
                    </a>
                  )}
                </div>
                <div className="flex items-center content-center">
                  <div className={""}>
                    <a
                      className={"text-sm font-medium text-red pointer"}
                      onClick={() => {
                        if (
                          window.confirm(
                            "Are you sure you want to remove this file?"
                          )
                        ) {
                          removeCompanyFile(company.id, file.id, token).then(
                            response => {
                              fetchCompanyFiles(company.id, token);
                            }
                          );
                        }
                      }}
                    >
                      <i className="ml-3 fas fa-trash-alt" />
                    </a>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        );
      });
  };
  return (
    <div>
      <div className="border-gray-200 sm:rounded-lg">
        <div className="pt-4 user-management">
          <CompanyTargetsForm company={company} />
        </div>
        <div className="pt-4 user-management">
          <CompanyNoteField company={company} note={company?.note} />
        </div>
        {isRolePlatformAdmin ? (
          <div className="py-10">
            <h3 className={"uppercase pt-5 border-t border-grey my-5"}>
              Assign company to a different agency
            </h3>
            <LiveSearchSimple
              label="Search For An Existing Agency"
              name="agency_name"
              getText={result => result.name}
              url={`${window.API}/search/agency`}
              onChange={agency => setAgency(agency)}
              query="agency"
              auth
            />
            {agency && (
              <ButtonPrimary onClick={() => assignAgency()}>
                Assign Company to Agency
              </ButtonPrimary>
            )}
          </div>
        ) : null}
        <h3 className={"uppercase pt-5 border-t border-grey"}>Upload File</h3>
        <form className="border-none pb-2" onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className={"col col-w-full md:col-w-1/2 mb-6"}>
              <Field
                name="name"
                label="Name of Download"
                component={renderFormInput}
              />
            </div>
          </div>
          <div className="row">
            <div className={"col col-w-full md:col-w-1/2 mb-6"}>
              <Field
                name="link"
                label="External Link - ignored if you upload a file below"
                component={renderFormInput}
              />
            </div>
          </div>
          <div className={"col col-w-full md:col-w-1/2 mb-6"}>
            <DropzoneArea
              type="document_plus"
              minWidth={"200px"}
              minHeight={"100px"}
              onDrop={uploadFile}
              uploading={uploading}
            />
            {fileError ? (
              <p className={"text-red"}>Unsupported File Type</p>
            ) : null}

            {file && (
              <div className={"col col-w-full md:col-w-1/2 mb-6"}>
                <p>
                  {file.name}{" "}
                  <span
                    role="button"
                    tabIndex="0"
                    className="pointer text-warning"
                  >
                    <i
                      className="ml-3 fas fa-trash-alt"
                      onClick={() => {
                        setFile(null);
                      }}
                    ></i>
                  </span>
                </p>
              </div>
            )}
            {!file && fileUrl && fileName && (
              <div className={"col col-w-full mb-6"}>
                <a
                  className={"font-bold"}
                  href={"#"}
                  onClick={() =>
                    handleDownload(fileName, fileUrl, fileExtension, token)
                  }
                >
                  Download {fileName}
                </a>
              </div>
            )}
          </div>

          <div className={"corp-form-buttons"}>
            <ButtonPrimary type="submit">
              {loading ? <Loading inline /> : "Save"}
            </ButtonPrimary>
            {/* {onDelete ?  <ButtonPrimaryRed onClick={onDelete} classes={'ml-1'}>*/}
            {/*  {submitting ? <Loading inline/> : "Delete Document"}*/}
            {/*</ButtonPrimaryRed> : null}*/}
          </div>
        </form>
        {success ? <Succeeded /> : null}
        {isFetchingCompanyFiles ? (
          <Loading />
        ) : (
          <div className={"border-t border-grey "}>
            <div className="max-w-full">
              <div className="overflow-hidden border-b border-gray-200 sm:rounded-lg bg-white p-5">
                <table className="edge-table">
                  <thead>{headings()}</thead>
                  <tbody className="divide-y divide-gray-200">
                    {fileList()}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

CompanyAgency = reduxForm({
  form: "corporateAccountDocumentForm",
  enableReinitialize: true,
})(CompanyAgency);

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAgency);
